import React from 'react';

const PageHero = ({ eyebrow, title, lead, image, testId = 'page-hero' }) => (
  <section className="pt-36 lg:pt-44 pb-20 lg:pb-28 bg-white" data-testid={testId}>
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
        <div className="lg:col-span-7">
          {eyebrow && <div className="overline mb-6">{eyebrow}</div>}
          <h1 className="display-xl text-cyan-vidat">{title}</h1>
          {lead && (
            <p className="mt-8 text-lg lg:text-xl text-stone-700 font-light leading-relaxed max-w-2xl">
              {lead}
            </p>
          )}
        </div>
        {image && (
          <div className="lg:col-span-5 mt-8 lg:mt-0">
            <div className="aspect-[4/5] overflow-hidden max-w-sm mx-auto lg:max-w-none">
              <img src={image} alt="" className="w-full h-full object-cover img-grayscale" />
            </div>
          </div>
        )}
      </div>
    </div>
  </section>
);

export default PageHero;
